import { render, staticRenderFns } from "./TierItem.vue?vue&type=template&id=6c6e0257&scoped=true&"
import script from "./TierItem.vue?vue&type=script&lang=js&"
export * from "./TierItem.vue?vue&type=script&lang=js&"
import style0 from "./TierItem.vue?vue&type=style&index=0&id=6c6e0257&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e0257",
  null
  
)

export default component.exports